import { createContext } from 'react'

export const HydrationContext = createContext<boolean | undefined>(undefined)
